import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import InputText from "../../components/input/InputText";
import { CircularProgress } from "@mui/material";
import InputSelect from "../../components/input/InputSelect";
import USER_ROLES from "../../functions/utilities";
import InputPassword from "../../components/input/InputPassword";
import CustomLoader from "../../components/loader";

const UserForm = (props) => {
  const { popUp, setPopUp, user, updateUser, newUser, setNewUser, addUser } =
    props;
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    id: "",
    email: "",
    userName: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
  });
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("");

  const handleEdit = () => {
    const { phoneNumber, ...rest } = formValues;
    const requestsData = { ...rest };
    if (phoneNumber !== "") {
      requestsData.phoneNumber = phoneNumber;
    }
    if (newPassword !== "" && confirmPassword !== "") {
      if (newUser) requestsData.password = newPassword;
      else requestsData.newPassword = newPassword;
      requestsData.confirmPassword = confirmPassword;
    }
    if ((role !== "" && role === "User") || role === "Admin") {
      requestsData.role = role;
    }
    console.log(requestsData);
    !newUser ? updateUser(requestsData) : addUser(requestsData);
    setPopUp(false);
    setNewUser(false);
  };

  const handleClose = () => {
    setPopUp(false);
    if (newUser) {
      setNewUser(false);
    }
  };

  useEffect(() => {
    if (!newUser) {
      setFormValues({
        id: user.id,
        email: user.email ?? "",
        userName: user.userName ?? "",
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
        phoneNumber: user.phoneNumber ?? "",
      });
    } else {
      setFormValues({
        email: "",
        userName: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
      });
      setRole("User");
    }
    setLoading(false);
  }, [newUser, user]);

  if (loading) {
    return (
      <div className="admin-content-loading">
        <CustomLoader />
      </div>
    );
  }

  return (
    popUp && (
      <div className="new-user-edit-popup">
        <div className="bg-dark" />
        <div className="popup-card">
          <CloseIcon className="cross" onClick={handleClose} />

          <h1>{newUser ? "New User" : "Edit User"}</h1>

          <form>
            <div className="flex">
              <label>Email: </label>
              <InputText
                className="input-text"
                placeholder="Email address"
                value={formValues.email}
                onChange={(e) =>
                  setFormValues((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </div>
            <div className="flex">
              <label>Username: </label>
              <InputText
                className="input-text"
                placeholder="User Name"
                value={formValues.userName}
                onChange={(e) =>
                  setFormValues((prev) => ({
                    ...prev,
                    userName: e.target.value,
                  }))
                }
              />
            </div>
            <div className="flex">
              <label> Firstname: </label>
              <InputText
                className="input-text"
                placeholder="First Name"
                value={formValues.firstName}
                onChange={(e) =>
                  setFormValues((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
              />
            </div>
            <div className="flex">
              <label>Lastname: </label>
              <InputText
                className="input-text"
                placeholder="Last Name"
                value={formValues.lastName}
                onChange={(e) =>
                  setFormValues((prev) => ({
                    ...prev,
                    lastName: e.target.value,
                  }))
                }
              />
            </div>
            <div className="flex">
              <label>Phone: </label>
              <InputText
                className="input-text"
                placeholder="Phone Number"
                value={formValues.phoneNumber}
                onChange={(e) =>
                  setFormValues((prev) => ({
                    ...prev,
                    phoneNumber: e.target.value,
                  }))
                }
              />
            </div>
            <div className="flex">
              <label>Password: </label>
              <InputPassword
                placeholder="Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <div className="flex">
              <label>Confirm: </label>
              <InputPassword
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
            <div className="flex">
              <label>Role: </label>
              <InputText
                className="input-text"
                placeholder="Role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              />
            </div>
          </form>
          <div className="save-actions">
            <div />
            <div className="flex">
              <ButtonPrimary
                text="Cancel"
                onClick={() => setPopUp(false)}
                className="mr-2 grey"
                outline
              />
              <ButtonPrimary
                text={newUser ? "Create" : "Save"}
                onClick={handleEdit}
              />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default UserForm;
